import { useContext } from 'react'
import type { InputHTMLAttributes } from 'react'

import { Container, InputContext } from './InputContext'

import type { ColorKeys } from '../../theme/color'

type InputAttributes = InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement>

interface InputProps extends InputAttributes {
  $shape?: 'box' | 'line'
  $borderColor?: ColorKeys
  block?: boolean
  multiline?: boolean
  icon?: any
}

// TODO: block="true" error
function Inner({ value, defaultValue, placeholder, disabled, onChange, ...props }: InputProps) {
  const { handleBlur, handleFocus, handleKeyDown } = useContext(InputContext)

  return (
    <input
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder}
      disabled={disabled}
      onChange={onChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      {...props}
    />
  )
}

export function Input(props: InputProps) {
  const { block, $borderColor, ...innerProps } = props
  return (
    <Container block={block} $borderColor={$borderColor} {...props}>
      <Inner {...innerProps} />
      {props?.icon ?? null}
    </Container>
  )
}

export type { InputProps }
